import React, { useState, useEffect } from "react";
import {
  Search,
  Download,
  RotateCcw,
  ChevronUp,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  Minus,
  Plus,
  Sheet, // For Excel files
  FileText, // For PDF files
} from "lucide-react";
import ExcelJS from "exceljs";
import {
  getBankAndBranchLogo,
  getThemeURL,
} from "../../../../../Services/EndPoints";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import { getData, postDataWithBody } from "../../../../../Services/Services";

const TableComponent = ({
  data,
  columns,
  subColumns,
  showDownload,
  showPDFDownload,
  showSearch,
  showPagination,
  enableSorting,
  tableType,
  title,
  showDateFilter,
  item,
  tablePagination,
  tableRowsPerPage,
  onTablePageChange,
  onTableRowsPerPageChange,
  expandLevel,
  selectedBankIds,
  selectedBranchIds,
  savedQueries,
  selectedDateField,
  editConfigIds,
}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [dateRange, setDateRange] = useState({
    startDate: null,
    endDate: null,
  });
  const [appliedDateRange, setAppliedDateRange] = useState({
    startDate: null,
    endDate: null,
  });
  const [expandedRows, setExpandedRows] = useState({});
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "ascending",
  });

  // New state for NiFi data filtering
  const [tableData, setTableData] = useState(data || []);
  const [loading, setLoading] = useState(false);

  const [loadingQueries, setLoadingQueries] = useState(false);
  const [queryError, setQueryError] = useState(null);

  // Add these state variables with other useState hooks
  const [userProfile, setUserProfile] = useState(null);
  const [logoFromApi, setLogoFromApi] = useState(null);
  const [bankName, setBankName] = useState("");
  const [bankData, setBankData] = useState(null);
  const [shouldShowBankLogo, setShouldShowBankLogo] = useState(false);

  console.log(selectedBankIds, "selectedbankidssssssssssss");
  console.log(selectedBranchIds, "selectedbankidssssssssssss1");

  // Add these helper functions before the main return statement
  const getUserProfile = async () => {
    try {
      const profile = await getData(getThemeURL);
      if (profile && profile.length > 0) {
        setUserProfile(profile[0]);
        // After getting profile, fetch logo with proper payload
        if (item.showBankLogo) {
          fetchLogoAndNameFromApi(profile[0]);
        }
      }
    } catch (error) {
      console.error("Error fetching user profile:", error);
      setUserProfile(null);
    }
  };

  const createPayload = (profile) => {
    let admin_role = "U"; // default value

    if (profile.is_admin === true) {
      admin_role = "HO";
    } else if (profile.role_name === "SUPER ADMIN") {
      admin_role = "SA";
    }

    return {
      admin_role: admin_role,
      bank_id: profile.bank_id || null,
      branch_id: profile.branch_id || null,
    };
  };

  const byteArrayToImageUrl = (byteArray) => {
    try {
      const uint8Array = new Uint8Array(byteArray);
      const blob = new Blob([uint8Array], { type: "image/png" });
      const imageUrl = URL.createObjectURL(blob);
      return imageUrl;
    } catch (error) {
      console.error("Error converting byte array to image:", error);
      return null;
    }
  };

  // Replace the checkSingleBankData function with this improved version
  const checkSingleBankData = () => {
    if (!tableData || tableData.length === 0) return false;

    // PRIORITY 1: Use selectedBranchIds if available and single
    if (selectedBranchIds && selectedBranchIds.length === 1) {
      return true;
    }

    // PRIORITY 2: Use selectedBankIds if available and single
    if (selectedBankIds && selectedBankIds.length === 1) {
      return true;
    }

    // PRIORITY 3: Use editConfigIds as fallback if available and single
    if (editConfigIds && editConfigIds.length === 1) {
      return true;
    }

    // Extract unique bank IDs from the table data as fallback
    const bankIds = new Set();

    tableData.forEach((row) => {
      // Check common bank ID field names
      const bankId = row.id || row.bankId || row.Bank_ID || row.bank_id;
      if (bankId) {
        bankIds.add(bankId);
      }
    });

    console.log("Bank IDs in table data:", Array.from(bankIds));

    // Show logo if there's exactly one bank in the data
    return bankIds.size === 1;
  };
  // Also update the fetchLogoAndNameFromApi function to handle branch selection better
  const fetchLogoAndNameFromApi = async (profile) => {
    try {
      const payload = createPayload(profile);
      const response = await postDataWithBody(
        getBankAndBranchLogo,
        payload,
        {}
      );

      if (Array.isArray(response) && response.length > 0) {
        console.log(response, "logooooooooo3");
        let bankData = null;

        // Determine which bank data to use based on user role and table data
        if (profile.role_name === "SUPER ADMIN" || profile.is_admin === true) {
          console.log(response, "logoooooooooo2");
          const shouldShowLogo = checkSingleBankData();

          if (shouldShowLogo) {
            console.log(response, "logoooooooooo1");

            // PRIORITY 1: Use selectedBranchIds if available and single
            if (selectedBranchIds && selectedBranchIds.length === 1) {
              const branchId = selectedBranchIds[0];
              console.log("Using single selectedBranchIds:", branchId);
              console.log(setLoadingQueries,setQueryError);

              // Search through all banks and their branches
              for (const bank of response) {
                if (bank.branches && Array.isArray(bank.branches)) {
                  const matchingBranch = bank.branches.find(
                    (branch) =>
                      branch.id == branchId ||
                      branch.branch_id == branchId ||
                      branch.Branch_ID == branchId
                  );

                  if (matchingBranch) {
                    // Found the branch, use branch data
                    bankData = {
                      ...bank,
                      ...matchingBranch,
                      isBranch: true,
                    };
                    break;
                  }
                }
              }
            }
            // PRIORITY 2: Use selectedBankIds if available and single
            else if (selectedBankIds && selectedBankIds.length === 1) {
              const bankId = selectedBankIds[0];
              console.log("Using single selectedBankIds:", bankId);

              bankData = response.find(
                (bank) =>
                  bank.id == bankId ||
                  bank.bank_id == bankId ||
                  bank.Bank_ID == bankId
              );
            }
            // PRIORITY 3: Use editConfigIds as fallback if available and single
            else if (editConfigIds && editConfigIds.length == 1) {
              const configId = editConfigIds[0];
              console.log("Using single editConfigIds as fallback:", configId);

              // Try to find bank/branch by config ID
              bankData = response.find(
                (bank) =>
                  bank.id == configId ||
                  bank.bank_id == configId ||
                  bank.Bank_ID == configId ||
                  (bank.branches &&
                    bank.branches.some(
                      (branch) =>
                        branch.id == configId || branch.branch_id == configId
                    ))
              );

              // If we found a bank but need branch-specific data
              if (bankData && bankData.branches) {
                const matchingBranch = bankData.branches.find(
                  (branch) =>
                    branch.id == configId || branch.branch_id == configId
                );
                if (matchingBranch) {
                  bankData = {
                    ...bankData,
                    ...matchingBranch,
                    isBranch: true,
                  };
                }
              }
            }
            // PRIORITY 4: Fallback to bank_id from table data
            else {
              const tableIdToMatch = tableData[0]?.bank_id;
              console.log("Using bank_id as fallback:", tableIdToMatch);

              if (tableIdToMatch) {
                bankData = response.find(
                  (bank) =>
                    bank.id == tableIdToMatch ||
                    bank.bank_id == tableIdToMatch ||
                    bank.Bank_ID == tableIdToMatch
                );
              }
            }

            console.log(bankData, "bankDataaaaaaaaa");

            // If no match found, use first available bank data
            if (!bankData && response.length > 0) {
              bankData = response[0];
            }
          } else {
            // Multiple banks or branches in selection, don't show logo
            setShouldShowBankLogo(false);
            return;
          }
        } else {
          // For non-Super Admin users, use the first response (their bank)
          bankData = response[0];
        }

        if (!bankData) {
          setShouldShowBankLogo(false);
          return;
        }

        setBankData(bankData);
        setShouldShowBankLogo(true);

        // Set bank/branch name
        if (bankData.branchName) {
          setBankName(bankData.branchName);
        } else if (bankData.bankName) {
          setBankName(bankData.bankName);
        } else {
          setBankName("");
        }

        // Check if image field exists and is an array with data
        // Priority: branch image -> bank image
        if (
          bankData.hasOwnProperty("image") &&
          Array.isArray(bankData.image) &&
          bankData.image.length > 0
        ) {
          const imageUrl = byteArrayToImageUrl(bankData.image);
          setLogoFromApi(imageUrl);
        } else if (
          bankData.bankLogo &&
          Array.isArray(bankData.bankLogo) &&
          bankData.bankLogo.length > 0
        ) {
          // Fallback to bank logo if branch logo not available
          const imageUrl = byteArrayToImageUrl(bankData.bankLogo);
          setLogoFromApi(imageUrl);
        } else {
          setLogoFromApi(null);
        }
      } else {
        setShouldShowBankLogo(false);
      }
    } catch (error) {
      console.error("Error fetching logo and bank name from API:", error);
      setLogoFromApi(null);
      setShouldShowBankLogo(false);
    }
  };
  // Update the other useEffect that depends on data changes
  useEffect(() => {
    if (
      item.showBankLogo &&
      userProfile &&
      userProfile.role_name === "SUPER ADMIN"
    ) {
      // Re-check if we should show logo when chart data changes
      const hasSingleBank = checkSingleBankData();
      setShouldShowBankLogo(hasSingleBank);

      if (hasSingleBank && bankData) {
        // Re-fetch logo for the specific bank if needed
        fetchLogoAndNameFromApi(userProfile);
      }
    }
  }, [
    tableData.length,
    userProfile,
    selectedBankIds,
    selectedBranchIds,
    editConfigIds,
  ]); // Add all relevant dependencies
  useEffect(() => {
    if (item.showBankLogo) {
      getUserProfile();
    }
  }, [item.showBankLogo]);

  // Update the other useEffect that depends on data changes
  useEffect(() => {
    if (
      item.showBankLogo &&
      userProfile &&
      userProfile.role_name === "SUPER ADMIN"
    ) {
      // Re-check if we should show logo when chart data changes
      const hasSingleBank = checkSingleBankData();
      setShouldShowBankLogo(hasSingleBank);

      if (hasSingleBank && bankData) {
        // Re-fetch logo for the specific bank if needed
        fetchLogoAndNameFromApi(userProfile);
      }
    }
  }, [
    tableData.length,
    userProfile,
    selectedBankIds,
    selectedBranchIds,
    editConfigIds,
  ]); // Add all relevant dependencies
  // Cleanup effect for object URLs
  useEffect(() => {
    return () => {
      if (logoFromApi) {
        URL.revokeObjectURL(logoFromApi);
      }
    };
  }, [logoFromApi]);

  // Add useEffect to re-check bank data when tableData changes
  useEffect(() => {
    if (
      item.showBankLogo &&
      userProfile &&
      userProfile.role_name === "SUPER ADMIN"
    ) {
      // Re-check if we should show logo when table data changes
      const hasSingleBank = checkSingleBankData();
      console.log("Re-checking bank data:", { hasSingleBank });

      if (hasSingleBank) {
        // Re-fetch logo for the specific bank if needed
        fetchLogoAndNameFromApi(userProfile);
      } else {
        setShouldShowBankLogo(false);
      }
    }
  }, [tableData.length, item.showBankLogo]); // Only depend on length to avoid infinite loops

  useEffect(() => {
    if (item.showBankLogo && userProfile) {
      console.log("Filter change detected - rechecking bank data:", {
        selectedBankIds,
        selectedBranchIds,
        editConfigIds,
      });

      const hasSingleBank = checkSingleBankData();
      console.log("Should show bank logo after filter change:", hasSingleBank);

      setShouldShowBankLogo(hasSingleBank);

      if (hasSingleBank) {
        fetchLogoAndNameFromApi(userProfile);
      } else {
        // Clear logo when no single selection
        setLogoFromApi(null);
        setBankName("");
        setBankData(null);
      }
    }
  }, [
    selectedBankIds,
    selectedBranchIds,
    editConfigIds,
    item.showBankLogo,
    userProfile,
  ]); // This will trigger on filter changes
  console.log("table savedQueries", savedQueries);
  console.log("table DATA", data);
  console.log("selectedBankIds", selectedBankIds);
  console.log("selectedBranchIds", selectedBranchIds);

  console.log("Table LoadData called with new:", {
    selectedBankIds,
    selectedBranchIds,
    hasDataSource: !!item?.dataSource,
    currentDataLength: tableData.length,
    savedQueriesLength: savedQueries.length,
  });

  // Transform NiFi response to table data format
  const transformNiFiDataToTableFormat = (nifiResponse) => {
    try {
      console.log("Raw NiFi response for table:", nifiResponse);

      // Check if data is already in object format
      if (
        nifiResponse &&
        nifiResponse.status === "success" &&
        nifiResponse.data
      ) {
        const { data } = nifiResponse;

        // If data is already an array of objects, use it directly
        if (
          Array.isArray(data) &&
          data.length > 0 &&
          typeof data[0] === "object"
        ) {
          console.log("Table data is already in object format:", data);
          return data;
        }

        // If data is array of arrays with columns
        if (
          nifiResponse.columns &&
          Array.isArray(data) &&
          Array.isArray(data[0])
        ) {
          const { columns } = nifiResponse;
          const transformedData = data.map((row) => {
            const dataPoint = {};
            columns.forEach((column, index) => {
              let cleanKey = column
                .replace(/^(SUM|COUNT|AVG|MIN|MAX|DISTINCT)\(/i, "")
                .replace(/\)$/, "")
                .replace(/^.*\./, "");
              dataPoint[cleanKey] = row[index];
            });
            return dataPoint;
          });
          console.log(
            "Transformed table data from array of arrays:",
            transformedData
          );
          return transformedData;
        }
      }

      console.log("No valid table data found, returning empty array");
      return [];
    } catch (error) {
      console.error("Error transforming NiFi table data:", error);
      return [];
    }
  };

  const getButtonStyle = (baseColor) => ({
    padding: showSearch ? "8px 12px" : "10px 16px", // More padding when no search
    backgroundColor: baseColor,
    color: "white",
    border: "none",
    borderRadius: "6px",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    cursor: "pointer",
    fontWeight: "500",
    height: showSearch ? "36px" : "36px", // Slightly taller when no search
    minWidth: showSearch ? "50px" : "50px", // Consistent minimum width
  });

  // Function to fetch filtered data from NiFi
  const fetchFilteredData = async (bankIds, branchIds) => {
    try {
      if (!item?.dataSource || !savedQueries || savedQueries.length === 0) {
        console.log("No data source or saved queries available for table");
        return Array.isArray(data) ? data : [];
      }

      const currentDashboardWidgetId = `WIDGET_${item.id}`;
      const matchedQuery = savedQueries.find(
        (q) => q.dashboardWidgetId === currentDashboardWidgetId
      );
      console.log("Table matchedQuery", matchedQuery);
      console.log("Table serviceName", item.dataSource);

      if (!matchedQuery) {
        console.log(
          "No matching query found for table data source:",
          item.dataSource
        );
        return Array.isArray(data) ? data : [];
      }

      // Get query object
      const queryObject =
        typeof matchedQuery.queryBuilder === "string"
          ? JSON.parse(matchedQuery.queryBuilder)
          : matchedQuery.queryBuilder;

      // Extract table name from entity
      const entity = queryObject.entity || "";
      const tableName = entity.includes(".") ? entity.split(".")[1] : entity;

      // Get joins information
      const joins = queryObject.joins || [];
      const joinedTables = joins.map((join) => {
        const table = join.table || join.alias || "";
        return table.includes(".") ? table.split(".")[1] : table;
      });

      // Helper function to determine filter field names
      const determineFilterFields = () => {
        let bankFilterField = null;
        let branchFilterField = null;

        console.log("Table: Table name:", tableName);

        // FIRST CHECK: For any table that is NOT "bank" or "branch_details", use tableName.bank_id and tableName.branch_id
        if (tableName !== "bank" && tableName !== "branch_details") {
          bankFilterField = `${tableName}.bank_id`;
          branchFilterField = `${tableName}.branch_id`;
          return { bankFilterField, branchFilterField };
        }

        // If the first condition doesn't match, proceed with existing join logic
        // Check what tables are available
        const hasBankTable =
          tableName === "bank" || joinedTables.includes("bank");
        const hasBranchDetailsTable =
          tableName === "branch_details" ||
          joinedTables.includes("branch_details");
        const hasJoins = joins.length > 0;

        console.log("Table: Table analysis:", {
          tableName,
          joinedTables,
          hasBankTable,
          hasBranchDetailsTable,
          hasJoins,
        });

        // Determine bank filter field
        if (tableName === "bank") {
          // If entity is bank table
          bankFilterField = "bank.id";
        } else if (hasBankTable && hasJoins) {
          // If joins are there and bank table is available
          bankFilterField = "bank.id";
        } else if (
          !hasBankTable &&
          tableName !== "bank" &&
          tableName !== "branch_details"
        ) {
          // For core tables (not bank or branch_details), use table.bank_id
          bankFilterField = `${tableName}.bank_id`;
        } else if (!hasBankTable) {
          // If no bank table available, use current table with bank_id
          bankFilterField = `${tableName}.bank_id`;
        }

        // Determine branch filter field
        if (tableName === "branch_details") {
          // If entity is branch_details table
          branchFilterField = "branch_details.id";
        } else if (hasBranchDetailsTable && hasJoins) {
          // If joins are there and branch_details table is available
          branchFilterField = "branch_details.id";
        } else if (
          !hasBranchDetailsTable &&
          tableName !== "bank" &&
          tableName !== "branch_details"
        ) {
          // For core tables (not bank or branch_details), use table.branch_id
          branchFilterField = `${tableName}.branch_id`;
        } else {
          // Check joined tables for branch_id field
          const tableWithBranchId = joinedTables.find(
            (table) => table !== "bank" && table !== "branch_details"
          );
          if (tableWithBranchId) {
            branchFilterField = `${tableWithBranchId}.branch_id`;
          } else {
            branchFilterField = `${tableName}.branch_id`;
          }
        }

        return { bankFilterField, branchFilterField };
      };

      const { bankFilterField, branchFilterField } = determineFilterFields();

      console.log("Table: Determined filter fields:", {
        bankFilterField,
        branchFilterField,
      });

      const filters = {};

      // Add branch filter if branchIds provided and field determined
      if (branchIds && branchIds.length > 0 && branchFilterField) {
        filters[branchFilterField] = {
          operator: "IN",
          value: branchIds,
        };
      } else if (!branchIds || branchIds.length === 0) {
        // Explicitly send null when branchIds is not available
        if (branchFilterField) {
          filters[branchFilterField] = null;
        }
      }

      // Add bank filter if bankIds provided and field determined
      if (bankIds && bankIds.length > 0 && bankFilterField) {
        filters[bankFilterField] = {
          operator: "IN",
          value: bankIds,
        };
      }

      // Add date range filter if available
      // if (item.fromDate && item.toDate) {
      //   const dateRangeFilter = {
      //     [`${tableName}.created_on`]: {
      //       operator: "BETWEEN",
      //       value: [item.fromDate, item.toDate],
      //     },
      //   };
      //   Object.assign(filters, dateRangeFilter);
      // }

      // Merge all filters

      console.log("queryObject", queryObject);
      console.log("queryObject2", JSON.stringify(queryObject));
      const enhancedQuery = {
        ...queryObject,
        filters: {
          ...(queryObject.filters || {}),
          ...filters,
        },
      };

      console.log("Table: Executing NiFi query with filters:", enhancedQuery);

      const response = await fetch("/nifi/fetchQuery", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(enhancedQuery),
      });

      console.log(
        "JSON.stringify(enhancedQuery)",
        JSON.stringify(enhancedQuery)
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      console.log("Table: Filtered Query Result:", result);

      if (result.status === "error") {
        throw new Error(result.message || "Query execution failed");
      }

      // Transform NiFi response to table format
      if (result.status === "success" && result.data) {
        const transformedData = transformNiFiDataToTableFormat(result);
        console.log("Table: Final transformed data:", transformedData);
        return transformedData;
      }

      return [];
    } catch (error) {
      console.error("Table: Error fetching filtered data:", error);
      return Array.isArray(data) ? data : [];
    }
  };

  // Effect to handle data fetching when filters change
  useEffect(() => {
    const loadData = async () => {
      console.log("Table LoadData called with:", {
        selectedBankIds,
        selectedBranchIds,
        hasDataSource: !!item?.dataSource,
        currentDataLength: tableData.length,
        savedQueriesLength: savedQueries.length,
      });

      console.log("item?.dataSource", item);

      // Wait for saved queries to load before attempting data fetch
      if (loadingQueries) {
        console.log("Still loading queries, skipping table data fetch");
        return;
      }

      if (
        (selectedBankIds && selectedBankIds.length > 0) ||
        (selectedBranchIds && selectedBranchIds.length > 0)
      ) {
        setLoading(true);
        try {
          // First try to fetch from NiFi if dataSource is available
          if (item?.dataSource && savedQueries && savedQueries.length > 0) {
            console.log("Table: Attempting NiFi filtering:", {
              dataSource: item.dataSource,
              selectedBankIds,
              selectedBranchIds,
            });

            const fetchedData = await fetchFilteredData(
              selectedBankIds,
              selectedBranchIds
            );
            console.log("Table: About to set table data with:", fetchedData);

            // Force state update by creating new array reference
            setTableData([...fetchedData]);
          } else {
            // No NiFi data source, use local filtering only
            console.log(
              "Table: No NiFi dataSource, using local filtering only"
            );

            let filteredData = data || [];
            const hasBankId = filteredData.some(
              (entry) =>
                entry.hasOwnProperty("bank_id") ||
                entry.hasOwnProperty("bankId") ||
                entry.hasOwnProperty("Bank_ID")
            );

            const hasBranchId = filteredData.some(
              (entry) =>
                entry.hasOwnProperty("branchdetails_id") ||
                entry.hasOwnProperty("branch_id") ||
                entry.hasOwnProperty("branchId") ||
                entry.hasOwnProperty("Branch_ID")
            );

            // Priority 1: Filter by branch IDs if any branches are selected
            if (
              selectedBranchIds &&
              selectedBranchIds.length > 0 &&
              hasBranchId
            ) {
              filteredData = filteredData.filter((entry) => {
                const entryBranchId =
                  entry.branchdetails_id ||
                  entry.branch_id ||
                  entry.branchId ||
                  entry.Branch_ID;
                return selectedBranchIds.includes(entryBranchId);
              });
            }
            // Priority 2: Filter by bank IDs if no branches selected but banks are selected
            else if (
              selectedBankIds &&
              selectedBankIds.length > 0 &&
              hasBankId
            ) {
              filteredData = filteredData.filter((entry) => {
                const entryBankId =
                  entry.bank_id || entry.bankId || entry.Bank_ID;
                const entryBranchId =
                  entry.branchdetails_id ||
                  entry.branch_id ||
                  entry.branchId ||
                  entry.Branch_ID;

                // Check if this record has a branch_id
                const recordHasBranchId =
                  entryBranchId !== undefined &&
                  entryBranchId !== null &&
                  entryBranchId !== "";

                // If record has branch_id, exclude it from bank-level filtering
                if (recordHasBranchId) {
                  return false;
                }

                // Only include records that match selected bank and don't have branch_id
                return selectedBankIds.includes(entryBankId);
              });
            }

            setTableData([...filteredData]);
          }
        } catch (error) {
          console.error("Error loading table data:", error);
          setTableData([...(data || [])]);
        } finally {
          setLoading(false);
        }
      } else {
        console.log("No filters applied, using original table data");
        setTableData([...(data || [])]);
      }
    };

    loadData();
  }, [
    selectedBankIds,
    selectedBranchIds,
    data,
    item?.dataSource,
    savedQueries,
    item?.fromDate,
    item?.toDate,
    loadingQueries,
  ]);

  // Debug useEffect to track tableData changes
  useEffect(() => {
    console.log("Table data state updated:", {
      length: tableData.length,
      data: tableData,
      timestamp: new Date().toISOString(),
    });
  }, [tableData]);

  // Toggle row expansion
  const toggleRow = (rowId) => {
    setExpandedRows((prev) => ({ ...prev, [rowId]: !prev[rowId] }));
  };

  // Apply date filter
  const applyDateFilter = () => {
    setAppliedDateRange({
      startDate: dateRange.startDate,
      endDate: dateRange.endDate,
    });
  };

  // Reset date filter
  const resetDateFilter = () => {
    setDateRange({ startDate: null, endDate: null });
    setAppliedDateRange({ startDate: null, endDate: null });
  };

  // Handle sorting
  const handleSort = (key) => {
    let direction = "ascending";
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    setSortConfig({ key, direction });
  };

  // Helper function to generate pagination options
  const generatePaginationOptions = (totalRows) => {
    const baseOptions = [5, 10, 20, 50];

    if (totalRows > 50) baseOptions.push(100);
    if (totalRows > 100) baseOptions.push(250);
    if (totalRows > 250) baseOptions.push(500);
    if (totalRows > 500) baseOptions.push(1000);

    // Smart handling of very large datasets
    if (totalRows > 1000 && totalRows <= 5000) {
      baseOptions.push(2500);
      baseOptions.push(totalRows); // All
    } else if (totalRows > 5000) {
      baseOptions.push(2500, 5000);
      // Don't add "All" for very large datasets
    } else if (totalRows > 5) {
      baseOptions.push(totalRows);
    }

    return [...new Set(baseOptions)]
      .filter((option) => option <= totalRows)
      .sort((a, b) => a - b);
  };

  // Helper function to format column labels
  const formatColumnLabel = (columnName) => {
    if (!columnName) return "Date Field";

    const cleanName = columnName.includes(".")
      ? columnName.split(".").pop()
      : columnName;

    return cleanName
      .replace(/([A-Z])/g, " $1")
      .replace(/^./, (str) => str.toUpperCase())
      .replace(/_/g, " ");
  };

  // Format date for display
  const formatDateForDisplay = (dateString) => {
    if (!dateString) return "";

    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return dateString;

      const day = date.getDate().toString().padStart(2, "0");
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const year = date.getFullYear();

      return `${day}-${month}-${year}`;
    } catch (error) {
      return dateString;
    }
  };

  // Get badge color
  const getBadgeColor = (value) => {
    if (value <= 5) return "#10B981";
    if (value <= 10) return "#F59E0B";
    return "#EF4444";
  };

  // EARLY RETURN: Check for no initial data BEFORE any processing
  if (!data || !Array.isArray(data) || data.length === 0) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "200px",
          color: "#6b7280",
          fontSize: "14px",
          textAlign: "center",
          padding: "20px",
          flexDirection: "column",
          gap: "12px",
        }}
      >
        <div
          style={{
            padding: "16px",
            backgroundColor: "#fef3c7",
            borderRadius: "8px",
            border: "1px solid #f59e0b",
          }}
        >
          <div
            style={{
              color: "#92400e",
              fontWeight: "600",
              marginBottom: "4px",
            }}
          >
            No Data Available
          </div>
        </div>
      </div>
    );
  }

  // Show loading state for queries or data
  if (loading || loadingQueries) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "200px",
          color: "#6b7280",
          fontSize: "14px",
        }}
      >
        {loadingQueries ? "Loading ..." : "Loading table data..."}
      </div>
    );
  }

  // Show error state if queries failed to load
  if (queryError) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "200px",
          color: "#ef4444",
          fontSize: "14px",
          textAlign: "center",
          padding: "20px",
        }}
      >
        <div
          style={{
            padding: "16px",
            backgroundColor: "#fef2f2",
            borderRadius: "8px",
            border: "1px solid #ef4444",
          }}
        >
          <div style={{ fontWeight: "600", marginBottom: "4px" }}>
            Error Loading Queries
          </div>
          <div style={{ fontSize: "12px" }}>{queryError}</div>
        </div>
      </div>
    );
  }

  const currentPage = tablePagination || 1;
  const currentRowsPerPage = tableRowsPerPage || 5;

  const dateColumn = selectedDateField;

  const headerStyle = {
    backgroundColor: item.headerColor || "#f9fafb",
    color: item.headerTextColor || "#374151",
  };

  const subHeaderStyle = {
    backgroundColor: item.subHeaderColor || "#f1f5f9",
    color: item.subHeaderTextColor || "#334155",
  };

  // Sort columns by their order property before rendering
  const visibleColumns = columns
    .filter((c) => c.selected)
    .sort((a, b) => (a.order || 0) - (b.order || 0))
    .map((col) => ({
      ...col,
      label:
        col.label ||
        col.key
          .replace(/([A-Z])/g, " $1")
          .replace(/^./, (str) => str.toUpperCase()),
    }));

  const visibleSubColumns =
    tableType === "expandable"
      ? subColumns
          .filter((c) => c.selected)
          .sort((a, b) => (a.order || 0) - (b.order || 0))
          .map((col) => ({
            ...col,
            label:
              col.label ||
              col.key
                .replace(/([A-Z])/g, " $1")
                .replace(/^./, (str) => str.toUpperCase()),
          }))
      : [];

  // Apply date filtering if date column exists and dates are selected
  let filteredData = [...tableData]; // ✅ Use tableData instead of data
  if (
    showDateFilter &&
    dateColumn &&
    (appliedDateRange.startDate || appliedDateRange.endDate)
  ) {
    filteredData = tableData.filter((row) => {
      // ✅ Filter tableData instead of data
      let dateValue;
      if (dateColumn.includes(".")) {
        const fieldName = dateColumn.split(".").pop();
        dateValue = row[fieldName];
      } else {
        dateValue = row[dateColumn];
      }

      if (!dateValue) return false;

      try {
        const rowDate = new Date(dateValue);
        if (isNaN(rowDate.getTime())) return false;

        const startValid =
          !appliedDateRange.startDate ||
          rowDate >= new Date(appliedDateRange.startDate);
        const endValid =
          !appliedDateRange.endDate ||
          rowDate <=
            new Date(
              new Date(appliedDateRange.endDate).setHours(23, 59, 59, 999)
            );
        return startValid && endValid;
      } catch (error) {
        console.error("Error parsing date for filtering:", error);
        return false;
      }
    });
  }
  // Add this debug line after the date filtering section
  console.log("Date filtering debug:", {
    selectedDateField,
    dateColumn,
    appliedDateRange,
    tableDataLength: tableData.length,
    filteredDataLength: filteredData.length,
    sampleRow: tableData[0], // Check if the date field exists
  });

  // Apply search filtering if there's a search term
  if (searchTerm && showSearch) {
    filteredData = filteredData.filter((row) =>
      columns.some((column) => {
        const value = String(row[column.key] || "").toLowerCase();
        return value.includes(searchTerm.toLowerCase());
      })
    );
  }

  // Apply sorting if enabled
  let sortedData = [...filteredData];
  if (enableSorting && sortConfig.key) {
    sortedData.sort((a, b) => {
      if (a[sortConfig.key] < b[sortConfig.key]) {
        return sortConfig.direction === "ascending" ? -1 : 1;
      }
      if (a[sortConfig.key] > b[sortConfig.key]) {
        return sortConfig.direction === "ascending" ? 1 : -1;
      }
      return 0;
    });
  }

  // Calculate pagination
  const totalRows = sortedData.length;
  const indexOfLastRow = currentPage * currentRowsPerPage;
  const indexOfFirstRow = indexOfLastRow - currentRowsPerPage;
  const currentRows = sortedData.slice(indexOfFirstRow, indexOfLastRow);
  const totalPages = Math.ceil(totalRows / currentRowsPerPage);

  // Show no data message when filters are applied but no data matches (AFTER FILTRATION)
  if (
    tableData.length === 0 &&
    ((selectedBankIds && selectedBankIds.length > 0) ||
      (selectedBranchIds && selectedBranchIds.length > 0))
  ) {
    // const hasSelectedBranches =
    //   selectedBranchIds && selectedBranchIds.length > 0;
    // const hasSelectedBanks = selectedBankIds && selectedBankIds.length > 0;

    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "200px",
          color: "#6b7280",
          fontSize: "14px",
          textAlign: "center",
          padding: "20px",
          flexDirection: "column",
          gap: "12px",
        }}
      >
        <div
          style={{
            padding: "10px",
            backgroundColor: "#fef3c7",
            borderRadius: "8px",
            border: "1px solid #f59e0b",
          }}
        >
          <div
            style={{
              color: "#92400e",
              fontWeight: "600",
            }}
          >
            No Data Available
          </div>
        </div>
      </div>
    );
  }

  const downloadPDF = async () => {
    try {
      const doc = new jsPDF("l", "pt", "a4");
      let currentY = 50;

      let fontName = "Helvetica";
      doc.setFont(fontName);
      doc.setFontSize(13);

      const pdfTitle =
        item.pdfTitle !== undefined &&
        item.pdfTitle !== null &&
        item.pdfTitle.trim() !== ""
          ? item.pdfTitle.trim()
          : "";

      if (shouldShowBankLogo && bankName) {
        try {
          const pageWidth = doc.internal.pageSize.width;
          const centerX = pageWidth / 2;

          doc.setFont(fontName, "bold");
          const bankNameFontSize =
            bankData?.banknameFontsize || bankData?.branchNameFontsize || 16;
          doc.setFontSize(parseInt(bankNameFontSize));

          if (logoFromApi) {
            // Logo exists - show logo + name side by side
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");
            const img = new Image();
            img.crossOrigin = "anonymous";

            await new Promise((resolve, reject) => {
              img.onload = () => {
                canvas.width = img.width;
                canvas.height = img.height;
                ctx.drawImage(img, 0, 0);
                resolve();
              };
              img.onerror = reject;
              img.src = logoFromApi;
            });

            const logoDataURL = canvas.toDataURL("image/png");
            const logoWidth = 70;
            const logoHeight = 70;
            const textWidth = doc.getTextWidth(bankName);
            const spacing = 15;
            const totalWidth = logoWidth + spacing + textWidth;
            const startX = centerX - totalWidth / 2;

            doc.addImage(
              logoDataURL,
              "PNG",
              startX,
              currentY,
              logoWidth,
              logoHeight
            );
            doc.text(
              bankName,
              startX + logoWidth + spacing,
              currentY + logoHeight / 2 + 6
            );

            currentY += Math.max(logoHeight, 40) + 20;
          } else {
            // No logo - just show centered bank name
            doc.text(bankName, centerX, currentY, { align: "center" });
            currentY += 30;
          }

          doc.setFont(fontName, "normal");
          doc.setFontSize(13);
        } catch (error) {
          console.error("Error adding bank info to PDF:", error);
        }
      }

      const xOffset = doc.internal.pageSize.width / 2;
      doc.text(pdfTitle, xOffset, currentY, { align: "center" });
      currentY += 30;

      const pageWidth = doc.internal.pageSize.width;
      const leftMargin = 40;
      const rightMargin = 40;
      const availableWidth = pageWidth - leftMargin - rightMargin;

      const isExpandableTable =
        tableType === "expandable" &&
        visibleSubColumns &&
        visibleSubColumns.length > 0;

      if (isExpandableTable) {
        const mainHeaders = visibleColumns.map((col) => col.label);
        const subHeaders = visibleSubColumns.map((col) => col.label);
        const combinedHeaders = [...mainHeaders, ...subHeaders];
        const totalColumns = combinedHeaders.length;

        let columnWidth = availableWidth / totalColumns;
        let fontSize = 8;
        let tableMargin = leftMargin;

        if (totalColumns <= 5) {
          columnWidth = availableWidth / totalColumns;
          tableMargin = leftMargin;
          fontSize = 10;
        } else if (totalColumns > 10) {
          fontSize = 7;
          columnWidth = Math.max(50, columnWidth);
        }

        const combinedData = [];
        sortedData.forEach((row) => {
          const combinedRow = [];

          visibleColumns.forEach((col) => {
            let cellValue = row[col.key];

            if (typeof cellValue === "boolean") {
              cellValue = cellValue ? "Yes" : "No";
            } else if (
              col.type === "date" ||
              (typeof cellValue === "string" &&
                (/^\d{4}-\d{2}-\d{2}/.test(cellValue) ||
                  cellValue.includes("T")))
            ) {
              try {
                let dateValue = cellValue;

                if (typeof cellValue === "string" && cellValue.includes("T")) {
                  dateValue = cellValue.split("T")[0];
                }

                if (
                  typeof cellValue === "string" &&
                  cellValue.includes(" ") &&
                  !cellValue.includes("T")
                ) {
                  dateValue = cellValue.split(" ")[0];
                }

                const date = new Date(dateValue);
                if (!isNaN(date.getTime())) {
                  const day = date.getDate().toString().padStart(2, "0");
                  const month = (date.getMonth() + 1)
                    .toString()
                    .padStart(2, "0");
                  const year = date.getFullYear();
                  cellValue = `${day}-${month}-${year}`;
                }
              } catch (error) {
                console.error("PDF date formatting error:", error);
              }
            }

            if (
              cellValue === null ||
              cellValue === undefined ||
              String(cellValue).trim() === ""
            ) {
              cellValue = "N/A";
            }

            combinedRow.push(String(cellValue));
          });

          visibleSubColumns.forEach((col) => {
            let cellValue = row[col.key];

            if (typeof cellValue === "boolean") {
              cellValue = cellValue ? "Yes" : "No";
            } else if (
              col.type === "date" ||
              (typeof cellValue === "string" &&
                (/^\d{4}-\d{2}-\d{2}/.test(cellValue) ||
                  cellValue.includes("T")))
            ) {
              try {
                let dateValue = cellValue;

                if (typeof cellValue === "string" && cellValue.includes("T")) {
                  dateValue = cellValue.split("T")[0];
                }

                if (
                  typeof cellValue === "string" &&
                  cellValue.includes(" ") &&
                  !cellValue.includes("T")
                ) {
                  dateValue = cellValue.split(" ")[0];
                }

                const date = new Date(dateValue);
                if (!isNaN(date.getTime())) {
                  const day = date.getDate().toString().padStart(2, "0");
                  const month = (date.getMonth() + 1)
                    .toString()
                    .padStart(2, "0");
                  const year = date.getFullYear();
                  cellValue = `${day}-${month}-${year}`;
                }
              } catch (error) {
                console.error("PDF date formatting error:", error);
              }
            }

            if (
              cellValue === null ||
              cellValue === undefined ||
              String(cellValue).trim() === ""
            ) {
              cellValue = "N/A";
            }

            combinedRow.push(String(cellValue));
          });

          combinedData.push(combinedRow);
        });

        const combinedColumnStyles = {};
        combinedHeaders.forEach((header, index) => {
          combinedColumnStyles[index] = {
            cellWidth: columnWidth,
            fontSize: fontSize,
          };
        });

        doc.autoTable({
          head: [combinedHeaders],
          body: combinedData,
          startY: currentY,
          theme: "grid",
          headStyles: {
            fillColor: [59, 130, 246],
            textColor: [255, 255, 255],
            fontStyle: "bold",
            halign: "center",
            fontSize: fontSize,
          },
          bodyStyles: {
            fontSize: fontSize,
          },
          columnStyles: combinedColumnStyles,
          margin: {
            top: currentY,
            left: tableMargin,
            right: rightMargin,
            bottom: 40,
          },
          tableWidth: "wrap",
          didParseCell: function (data) {
            if (data.section === "body") {
              const cellValue = data.cell.raw;

              if (
                typeof cellValue === "number" ||
                (typeof cellValue === "string" &&
                  !isNaN(cellValue) &&
                  !isNaN(parseFloat(cellValue)) &&
                  cellValue.trim() !== "")
              ) {
                data.cell.styles.halign = "right";
              } else {
                data.cell.styles.halign = "left";
              }
            }
          },
        });
      } else {
        const tableHeaders = visibleColumns.map((col) => col.label);
        const totalColumns = visibleColumns.length;

        let columnWidth = availableWidth / totalColumns;
        let fontSize = 10;
        let tableMargin = leftMargin;

        if (totalColumns <= 5) {
          columnWidth = availableWidth / totalColumns;
          tableMargin = leftMargin;
          fontSize = 11;
        } else if (totalColumns > 8) {
          fontSize = 8;
          columnWidth = Math.max(60, columnWidth);
        }

        const tableData = [];

        sortedData.forEach((row) => {
          const rowData = [];
          visibleColumns.forEach((col) => {
            let cellValue = row[col.key];

            if (typeof cellValue === "boolean") {
              cellValue = cellValue ? "Yes" : "No";
            } else if (
              col.type === "date" ||
              (typeof cellValue === "string" &&
                (/^\d{4}-\d{2}-\d{2}/.test(cellValue) ||
                  cellValue.includes("T")))
            ) {
              try {
                let dateValue = cellValue;

                if (typeof cellValue === "string" && cellValue.includes("T")) {
                  dateValue = cellValue.split("T")[0];
                }

                if (
                  typeof cellValue === "string" &&
                  cellValue.includes(" ") &&
                  !cellValue.includes("T")
                ) {
                  dateValue = cellValue.split(" ")[0];
                }

                const date = new Date(dateValue);
                if (!isNaN(date.getTime())) {
                  const day = date.getDate().toString().padStart(2, "0");
                  const month = (date.getMonth() + 1)
                    .toString()
                    .padStart(2, "0");
                  const year = date.getFullYear();
                  cellValue = `${day}-${month}-${year}`;
                }
              } catch (error) {
                console.error("PDF date formatting error:", error);
              }
            }

            if (
              cellValue === null ||
              cellValue === undefined ||
              String(cellValue).trim() === ""
            ) {
              cellValue = "N/A";
            }

            rowData.push(String(cellValue));
          });
          tableData.push(rowData);
        });

        const columnStyles = {};
        visibleColumns.forEach((col, index) => {
          columnStyles[index] = {
            cellWidth: columnWidth,
            fontSize: fontSize,
          };
        });

        doc.autoTable({
          head: [tableHeaders],
          body: tableData,
          startY: currentY,
          theme: "grid",
          headStyles: {
            fillColor: [59, 130, 246],
            textColor: [255, 255, 255],
            fontStyle: "bold",
            halign: "center",
            fontSize: fontSize,
          },
          bodyStyles: {
            fontSize: fontSize,
          },
          columnStyles: columnStyles,
          margin: {
            top: currentY,
            left: tableMargin,
            right: rightMargin,
            bottom: 40,
          },
          tableWidth: "wrap",
          didParseCell: function (data) {
            if (data.section === "body") {
              const cellValue = data.cell.raw;

              if (
                typeof cellValue === "number" ||
                (typeof cellValue === "string" &&
                  !isNaN(cellValue) &&
                  !isNaN(parseFloat(cellValue)) &&
                  cellValue.trim() !== "")
              ) {
                data.cell.styles.halign = "right";
              } else {
                data.cell.styles.halign = "left";
              }
              data.cell.styles.fontSize = fontSize;
            }
          },
        });
      }

      // **UPDATED FOOTER SECTION WITH PAGE BREAK LOGIC**
      const pageHeight = doc.internal.pageSize.height;
      const footerHeight = 180; // Total height needed for footer
      const finalY = doc.lastAutoTable.finalY || currentY; // Get where table ended

      // Check if there's enough space for footer on current page
      if (finalY + footerHeight > pageHeight) {
        // Not enough space, add new page
        doc.addPage();
        currentY = 50; // Reset Y position for new page
      } else {
        // Use existing page
        currentY = finalY;
      }

      // Position footer at bottom of page
      let footerY = pageHeight - 180;

      doc.setFontSize(10);

      doc.text("Letter No. : ", 50, footerY + 100);
      doc.text("Date : ", 50, footerY + 120);
      doc.text("Copy : ", 50, footerY + 140);

      doc.text("XXXX", 550, footerY + 100);
      doc.text("XXXXXXXXXX", 550, footerY + 120);
      doc.text("XXXXXX", 550, footerY + 140);

      doc.setFont(fontName, "bold");
      doc.text("[ ]", 550, footerY + 160);
      doc.setFont(fontName, "normal");

      const now = new Date();
      const istDate = now.toISOString().split("T")[0].replace(/-/g, "");
      const hours = now.getHours().toString().padStart(2, "0");
      const minutes = now.getMinutes().toString().padStart(2, "0");
      const seconds = now.getSeconds().toString().padStart(2, "0");
      const istTime = `${hours}${minutes}${seconds}`;
      const fileTimestamp = `${istDate}_${istTime}`;
      const fileTitle = title.replace(/\s+/g, "_").toLowerCase();
      const filename = `${fileTitle}_${fileTimestamp}.pdf`;

      doc.save(filename);
    } catch (error) {
      console.error("Error generating PDF:", error);
      alert("Error generating PDF. Please try again.");
    }
  };

  // Download Excel function (updated to use tableData instead of data)
  const downloadExcel = async () => {
    try {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Data");

      let currentRow = 1;

      // Add bank logo and name if enabled
      if (shouldShowBankLogo && bankName) {
        try {
          if (logoFromApi) {
            // Logo exists - add logo and name
            const response = await fetch(logoFromApi);
            const arrayBuffer = await response.arrayBuffer();

            const imageId = workbook.addImage({
              buffer: arrayBuffer,
              extension: "png",
            });

            worksheet.addImage(imageId, {
              tl: { col: 0, row: 0 },
              ext: { width: 100, height: 100 },
            });

            const bankNameCell = worksheet.getCell("B1");
            bankNameCell.value = bankName;
            bankNameCell.font = {
              bold: true,
              size: parseInt(
                bankData?.banknameFontsize || bankData?.branchNameFontsize || 16
              ),
            };
            bankNameCell.alignment = { vertical: "middle", horizontal: "left" };

            worksheet.getRow(1).height = 75;
            worksheet.getRow(2).height = 25;
            currentRow = 4;
          } else {
            // No logo - just add centered bank name
            const bankNameCell = worksheet.getCell("A1");
            bankNameCell.value = bankName;
            bankNameCell.font = {
              bold: true,
              size: parseInt(
                bankData?.banknameFontsize || bankData?.branchNameFontsize || 16
              ),
            };
            bankNameCell.alignment = {
              vertical: "middle",
              horizontal: "center",
            };

            // Merge cells across all columns for centered text
            const totalColumns =
              visibleColumns.length +
              (tableType === "expandable" && visibleSubColumns.length > 0
                ? visibleSubColumns.length
                : 0);
            worksheet.mergeCells(
              `A1:${String.fromCharCode(64 + totalColumns)}1`
            );

            worksheet.getRow(1).height = 30;
            worksheet.getRow(2).height = 15;
            currentRow = 3;
          }
        } catch (error) {
          console.error("Error adding bank info to Excel:", error);
          currentRow = 1;
        }
      }

      // Add title if provided
      const titleText =
        item.pdfTitle !== undefined &&
        item.pdfTitle !== null &&
        item.pdfTitle.trim() !== ""
          ? item.pdfTitle.trim()
          : null;

      if (titleText) {
        // Add title row
        worksheet.getCell(`A${currentRow}`).value = titleText;

        // Style the title row
        const titleRow = worksheet.getRow(currentRow);
        titleRow.font = { bold: true, size: 16 };
        titleRow.alignment = { horizontal: "center" };

        // Merge cells for title span across all columns
        const totalColumns =
          visibleColumns.length +
          (tableType === "expandable" && visibleSubColumns.length > 0
            ? visibleSubColumns.length
            : 0);
        worksheet.mergeCells(
          `A${currentRow}`,
          `${String.fromCharCode(64 + totalColumns)}${currentRow}`
        );

        currentRow += 2; // Add spacing after title
      }

      // Add header row
      const headerRow = visibleColumns.map((col) => col.label);
      if (tableType === "expandable" && visibleSubColumns.length > 0) {
        headerRow.push(...visibleSubColumns.map((col) => col.label));
      }
      worksheet.addRow(headerRow);

      // Style header row
      const headerRowIndex = currentRow;
      currentRow++;

      const headerRowObj = worksheet.getRow(headerRowIndex);
      headerRowObj.font = { bold: true };
      headerRowObj.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFE0E0E0" },
      };

      // Add data rows
      if (!sortedData || sortedData.length === 0) {
        const naRow = new Array(headerRow.length).fill("N/A");
        worksheet.addRow(naRow);
      } else {
        sortedData.forEach((row, rowIndex) => {
          const dataRow = [];

          // Process main columns with enhanced date formatting
          visibleColumns.forEach((col, colIndex) => {
            const cellValue = row[col.key];
            let processedValue = cellValue;

            // Handle boolean values
            if (typeof cellValue === "boolean") {
              processedValue = cellValue ? "Yes" : "No";
            } else {
              // Enhanced date field detection and formatting
              const isDateField =
                col.type === "date" ||
                (typeof cellValue === "string" &&
                  (/^\d{4}-\d{2}-\d{2}/.test(cellValue) || // YYYY-MM-DD
                    cellValue.includes("T"))); // ISO timestamp

              if (isDateField && cellValue) {
                try {
                  let dateValue = cellValue;

                  // Handle timestamp - extract date part if it contains 'T'
                  if (
                    typeof cellValue === "string" &&
                    cellValue.includes("T")
                  ) {
                    dateValue = cellValue.split("T")[0];
                  }

                  // Handle space-separated timestamps
                  if (
                    typeof cellValue === "string" &&
                    cellValue.includes(" ") &&
                    !cellValue.includes("T")
                  ) {
                    dateValue = cellValue.split(" ")[0];
                  }

                  const date = new Date(dateValue);
                  if (!isNaN(date.getTime())) {
                    const day = date.getDate().toString().padStart(2, "0");
                    const month = (date.getMonth() + 1)
                      .toString()
                      .padStart(2, "0");
                    const year = date.getFullYear();
                    processedValue = `${day}-${month}-${year}`;
                  }
                } catch (error) {
                  console.error("Excel date formatting error:", error);
                  processedValue = cellValue;
                }
              }
            }

            dataRow.push(
              processedValue === null ||
                processedValue === undefined ||
                String(processedValue).trim() === ""
                ? "N/A"
                : processedValue
            );
          });

          // Process sub columns for expandable tables with enhanced date formatting
          if (tableType === "expandable") {
            visibleSubColumns.forEach((col) => {
              const cellValue = row[col.key];
              let processedValue = cellValue;

              // Handle boolean values
              if (typeof cellValue === "boolean") {
                processedValue = cellValue ? "Yes" : "No";
              } else {
                // Enhanced date field detection and formatting
                const isDateField =
                  col.type === "date" ||
                  (typeof cellValue === "string" &&
                    (/^\d{4}-\d{2}-\d{2}/.test(cellValue) || // YYYY-MM-DD
                      cellValue.includes("T"))); // ISO timestamp

                if (isDateField && cellValue) {
                  try {
                    let dateValue = cellValue;

                    // Handle timestamp - extract date part if it contains 'T'
                    if (
                      typeof cellValue === "string" &&
                      cellValue.includes("T")
                    ) {
                      dateValue = cellValue.split("T")[0];
                    }

                    // Handle space-separated timestamps
                    if (
                      typeof cellValue === "string" &&
                      cellValue.includes(" ") &&
                      !cellValue.includes("T")
                    ) {
                      dateValue = cellValue.split(" ")[0];
                    }

                    const date = new Date(dateValue);
                    if (!isNaN(date.getTime())) {
                      const day = date.getDate().toString().padStart(2, "0");
                      const month = (date.getMonth() + 1)
                        .toString()
                        .padStart(2, "0");
                      const year = date.getFullYear();
                      processedValue = `${day}-${month}-${year}`;
                    }
                  } catch (error) {
                    console.error("Excel date formatting error:", error);
                    processedValue = cellValue;
                  }
                }
              }

              dataRow.push(
                processedValue === null ||
                  processedValue === undefined ||
                  String(processedValue).trim() === ""
                  ? "N/A"
                  : processedValue
              );
            });
          }

          worksheet.addRow(dataRow);
        });
      }

      // Set column widths
      worksheet.columns.forEach((column) => {
        column.width = 15;
      });

      // Generate and download file
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;

      // Generate filename with same timestamp format as PDF
      const now = new Date();
      const istDate = now.toISOString().split("T")[0].replace(/-/g, ""); // YYYYMMDD
      const hours = now.getHours().toString().padStart(2, "0");
      const minutes = now.getMinutes().toString().padStart(2, "0");
      const seconds = now.getSeconds().toString().padStart(2, "0");
      const istTime = `${hours}${minutes}${seconds}`;
      const fileTimestamp = `${istDate}_${istTime}`;
      const fileTitle = title.replace(/\s+/g, "_").toLowerCase();
      const filename = `${fileTitle}_${fileTimestamp}.xlsx`;

      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error generating Excel:", error);
      alert("Error generating Excel file. Please try again.");
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        overflowX: "auto",
      }}
    >
      {/* Date Filter Section */}
      {showDateFilter && (
        <div
          style={{
            flexShrink: 0, // Prevent shrinking
            display: "flex",
            gap: "16px",
            marginBottom: "16px",
            alignItems: "flex-start",
            padding: "12px",
            backgroundColor: "#f8fafc",
            borderRadius: "8px",
            flexWrap: "wrap",
            position: "relative",
            zIndex: 25,
          }}
        >
          <div
            style={{
              fontSize: "14px",
              fontWeight: "500",
              color: "#374151",
              alignSelf: "center",
              minWidth: "fit-content",
              marginTop: "-7px",
            }}
          >
            Filter by {formatColumnLabel(selectedDateField)}:
          </div>

          {/* From Date Section */}
          <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
            <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
              <label style={{ fontSize: "14px", color: "#4b5563" }}>
                From:
              </label>
              <input
                type="date"
                value={
                  dateRange.startDate
                    ? dateRange.startDate.toISOString().split("T")[0]
                    : ""
                }
                onChange={(e) => {
                  const selectedDate = e.target.value;
                  const today = new Date().toISOString().split("T")[0];

                  if (selectedDate > today) {
                    const todayDate = new Date(today);
                    let updatedRange = {
                      startDate: todayDate,
                      tableFromDateError:
                        "Future dates are not allowed. Date has been set to today.",
                    };

                    if (
                      dateRange.endDate &&
                      today > dateRange.endDate.toISOString().split("T")[0]
                    ) {
                      updatedRange.endDate = null;
                      updatedRange.tableToDateError =
                        "To Date cleared because From Date was adjusted to today.";
                    } else {
                      updatedRange.endDate = dateRange.endDate;
                    }

                    setDateRange(updatedRange);

                    setTimeout(() => {
                      setDateRange((prev) => ({
                        ...prev,
                        tableFromDateError: null,
                      }));
                    }, 3000);

                    return;
                  }

                  const newStartDate = selectedDate
                    ? new Date(selectedDate)
                    : null;
                  let updatedRange = {
                    startDate: newStartDate,
                    tableFromDateError: null,
                  };

                  if (
                    newStartDate &&
                    dateRange.endDate &&
                    newStartDate > dateRange.endDate
                  ) {
                    updatedRange.endDate = null;
                    updatedRange.tableToDateError =
                      "To Date cleared because it was earlier than From Date.";

                    setTimeout(() => {
                      setDateRange((prev) => ({
                        ...prev,
                        tableToDateError: null,
                      }));
                    }, 3000);
                  } else {
                    updatedRange.endDate = dateRange.endDate;
                  }

                  setDateRange(updatedRange);
                }}
                max={new Date().toISOString().split("T")[0]}
                style={{
                  width: "140px",
                  padding: "14px 8px",
                  borderRadius: "6px",
                  border: dateRange.tableFromDateError
                    ? "1px solid #ef4444"
                    : "1px solid #d1d5db",
                  fontSize: "13px",
                  height: "30px",
                  lineHeight: "1",
                  boxSizing: "border-box",
                  paddingBottom: "13px",
                }}
                onFocus={(e) => (e.target.style.borderColor = "#1a7a73")}
                onBlur={(e) =>
                  (e.target.style.borderColor = dateRange.tableFromDateError
                    ? "#ef4444"
                    : "#d1d5db")
                }
              />
            </div>
            {dateRange.tableFromDateError && (
              <span
                style={{
                  color: "#ef4444",
                  fontSize: "12px",
                  maxWidth: "200px",
                  lineHeight: "1.2",
                  marginLeft: "40px",
                }}
              >
                {dateRange.tableFromDateError}
              </span>
            )}
          </div>

          {/* To Date Section */}
          <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
            <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
              <label style={{ fontSize: "14px", color: "#4b5563" }}>To:</label>
              <input
                type="date"
                value={
                  dateRange.endDate
                    ? dateRange.endDate.toISOString().split("T")[0]
                    : ""
                }
                onChange={(e) => {
                  const selectedDate = e.target.value;
                  const today = new Date().toISOString().split("T")[0];

                  if (selectedDate > today) {
                    setDateRange({
                      ...dateRange,
                      endDate: new Date(today),
                      tableToDateError:
                        "Future dates are not allowed. Date has been set to today.",
                    });

                    setTimeout(() => {
                      setDateRange((prev) => ({
                        ...prev,
                        tableToDateError: null,
                      }));
                    }, 3000);

                    return;
                  }

                  const newEndDate = selectedDate
                    ? new Date(selectedDate)
                    : null;

                  if (
                    newEndDate &&
                    dateRange.startDate &&
                    newEndDate < dateRange.startDate
                  ) {
                    setDateRange({
                      ...dateRange,
                      endDate: newEndDate,
                      tableToDateError:
                        "To Date cannot be earlier than From Date.",
                    });

                    return;
                  }

                  setDateRange({
                    ...dateRange,
                    endDate: newEndDate,
                    tableToDateError: null,
                    tableFromDateError: null,
                  });
                }}
                max={new Date().toISOString().split("T")[0]}
                min={
                  dateRange.startDate
                    ? dateRange.startDate.toISOString().split("T")[0]
                    : ""
                }
                style={{
                  width: "140px",
                  padding: "14px 8px",
                  borderRadius: "6px",
                  border: dateRange.tableToDateError
                    ? "1px solid #ef4444"
                    : "1px solid #d1d5db",
                  fontSize: "13px",
                  height: "30px",
                  lineHeight: "1",
                  boxSizing: "border-box",
                  paddingBottom: "13px",
                }}
                onFocus={(e) => (e.target.style.borderColor = "#1a7a73")}
                onBlur={(e) =>
                  (e.target.style.borderColor = dateRange.tableToDateError
                    ? "#ef4444"
                    : "#d1d5db")
                }
              />
            </div>
            {dateRange.tableToDateError && (
              <span
                style={{
                  color: "#ef4444",
                  fontSize: "12px",
                  maxWidth: "200px",
                  lineHeight: "1.2",
                  marginLeft: "25px",
                }}
              >
                {dateRange.tableToDateError}
              </span>
            )}
          </div>

          {/* Buttons */}
          <button
            onClick={applyDateFilter}
            disabled={
              dateRange.tableFromDateError ||
              dateRange.tableToDateError ||
              (dateRange.startDate && !dateRange.endDate) ||
              (dateRange.startDate &&
                dateRange.endDate &&
                dateRange.startDate > dateRange.endDate)
            }
            style={{
              padding: "8px 16px",
              backgroundColor:
                dateRange.tableFromDateError ||
                dateRange.tableToDateError ||
                (dateRange.startDate && !dateRange.endDate) ||
                (dateRange.startDate &&
                  dateRange.endDate &&
                  dateRange.startDate > dateRange.endDate)
                  ? "#9ca3af"
                  : "#1a7a73",
              color: "white",
              border: "none",
              borderRadius: "6px",
              cursor:
                dateRange.tableFromDateError ||
                dateRange.tableToDateError ||
                (dateRange.startDate && !dateRange.endDate) ||
                (dateRange.startDate &&
                  dateRange.endDate &&
                  dateRange.startDate > dateRange.endDate)
                  ? "not-allowed"
                  : "pointer",
              fontSize: "14px",
              display: "flex",
              alignItems: "center",
              gap: "8px",
              opacity:
                dateRange.startDate &&
                dateRange.endDate &&
                dateRange.startDate > dateRange.endDate
                  ? 0.6
                  : 1,
              height: "fit-content",
              alignSelf: "flex-start",
            }}
          >
            Apply
          </button>

          <button
            onClick={() => {
              resetDateFilter();
              setDateRange((prev) => ({
                ...prev,
                tableFromDateError: null,
                tableToDateError: null,
              }));
            }}
            style={{
              padding: "8px 16px",
              backgroundColor: "#f3f4f6",
              color: "#4b5563",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer",
              fontSize: "14px",
              display: "flex",
              alignItems: "center",
              gap: "8px",
              height: "fit-content",
              alignSelf: "flex-start",
            }}
          >
            <RotateCcw size={16} />
            Reset
          </button>
        </div>
      )}

      {/* Search/Download Section */}
      {(showSearch || showDownload || showPDFDownload) && (
        <div
          style={{
            flexShrink: 0,
            display: "flex",
            justifyContent: showSearch ? "space-between" : "flex-end", // Conditional alignment
            alignItems: "center", // Add vertical alignment
            marginBottom: "16px",
            gap: showSearch ? "100px" : "0px", // No gap when no search
          }}
        >
          {/* Search section */}
          {showSearch && (
            <div style={{ position: "relative", flex: 1 }}>
              <Search
                size={16}
                color="#6b7280"
                style={{
                  position: "absolute",
                  left: "12px",
                  top: "50%",
                  transform: "translateY(-50%)",
                }}
              />
              <input
                type="text"
                placeholder="Search table..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={{
                  padding: "8px 12px 8px 36px",
                  borderRadius: "6px",
                  border: "1px solid #d1d5db",
                  outline: "none",
                  fontSize: "14px",
                  minWidth: "150px",
                  maxWidth: "300px",
                  width: "100%",
                }}
              />
            </div>
          )}

          {/* Download buttons container */}
          <div
            style={{
              display: "flex",
              gap: "12px",
              alignItems: "center", // Ensure vertical alignment
            }}
          >
            {/* Excel button with conditional styling */}
            {showDownload && (
              <button
                onClick={downloadExcel}
                style={getButtonStyle("#10B981")}
                title="Export to Excel"
              >
                <Download size={14} />
                <Sheet size={14} />
              </button>
            )}

            {/* PDF button with conditional styling */}
            {showPDFDownload && (
              <button
                onClick={downloadPDF}
                style={getButtonStyle("#EF4444")}
                title="Export to PDF"
              >
                <Download size={14} />
                <FileText size={14} />
              </button>
            )}
          </div>
        </div>
      )}

      {/* Table Section - This takes remaining space */}
      <div
        style={{
          flex: 1,
          overflowY: "auto",
          position: "relative",
          minHeight: 0, // Important for flex child with overflow
        }}
      >
        <table
          style={{
            width: "100%",
            borderCollapse: "separate",
            borderSpacing: "0",
            position: "relative",
            border: "1px solid #d1d5db",
            borderRadius: "8px",
            overflow: "hidden",
          }}
        >
          <thead
            style={{
              position: "sticky",
              top: 0,
              zIndex: 20,
              ...headerStyle,
            }}
          >
            <tr style={{ borderBottom: "2px solid #d1d5db" }}>
              {tableType === "expandable" && (
                <th
                  style={{
                    width: "40px",
                    padding: "12px 8px",
                    background: item.headerColor,
                    position: "sticky",
                    top: 0,
                    zIndex: 21,
                    borderRight: "1px solid #d1d5db",
                    borderTopLeftRadius: "8px",
                  }}
                ></th>
              )}
              {visibleColumns.map((column, index) => (
                <th
                  key={column.key}
                  style={{
                    padding: "12px 16px",
                    textAlign: "center",
                    fontWeight: "600",
                    color: item.headerTextColor || "#374151",
                    background: item.headerColor,
                    fontSize: "14px",
                    cursor: enableSorting ? "pointer" : "default",
                    position: "sticky",
                    top: 0,
                    zIndex: 21,
                    borderRight:
                      index < visibleColumns.length - 1
                        ? "1px solid #d1d5db"
                        : "none",
                    borderTopLeftRadius:
                      tableType !== "expandable" && index === 0 ? "8px" : "0",
                    borderTopRightRadius:
                      index === visibleColumns.length - 1 ? "8px" : "0",
                  }}
                  onClick={() => enableSorting && handleSort(column.key)}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                      justifyContent: "center",
                    }}
                  >
                    {column.label}
                    {enableSorting &&
                      sortConfig.key === column.key &&
                      (sortConfig.direction === "ascending" ? (
                        <ChevronUp size={14} />
                      ) : (
                        <ChevronDown size={14} />
                      ))}
                  </div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {currentRows.map((row, rowIndex) => (
              <React.Fragment key={rowIndex}>
                <tr
                  style={{
                    borderBottom: "1px solid #d1d5db",
                    backgroundColor: expandedRows[rowIndex]
                      ? "#f8fafc"
                      : "transparent",
                  }}
                >
                  {tableType === "expandable" && (
                    <td
                      style={{
                        padding: "12px 8px",
                        borderRight: "1px solid #d1d5db",
                        borderBottom: "1px solid #d1d5db",
                      }}
                    >
                      <button
                        onClick={() => toggleRow(rowIndex)}
                        style={{
                          background: "none",
                          border: "none",
                          cursor: "pointer",
                          padding: "4px",
                          borderRadius: "4px",
                        }}
                      >
                        {expandedRows[rowIndex] ? (
                          <Minus size={16} color="#64748b" />
                        ) : (
                          <Plus size={16} color="#64748b" />
                        )}
                      </button>
                    </td>
                  )}
                  {visibleColumns.map((column, index) => (
                    <td
                      key={column.key}
                      style={{
                        padding: "0px 5px",
                        fontSize: "14px",
                        color: "#374151",
                        textAlign: column.alignment || "left", // Apply alignment
                        borderRight:
                          index < visibleColumns.length - 1
                            ? "1px solid #d1d5db"
                            : "none",
                        borderBottom: "1px solid #d1d5db",
                      }}
                    >
                      {column.type === "badge" ? (
                        <span
                          style={{
                            backgroundColor: getBadgeColor(row[column.key]),
                            color: "white",
                            padding: "4px 8px",
                            borderRadius: "12px",
                            fontSize: "12px",
                            fontWeight: "500",
                          }}
                        >
                          {row[column.key]}
                        </span>
                      ) : (
                        (() => {
                          const value = row[column.key];

                          // Handle boolean values
                          if (typeof value === "boolean") {
                            return value ? "Yes" : "No";
                          }

                          const isDateField =
                            column.type === "date" ||
                            (typeof value === "string" &&
                              /\d{4}-\d{2}-\d{2}/.test(value));

                          if (isDateField && value) {
                            return formatDateForDisplay(value);
                          }

                          // Use strict null/undefined check to avoid converting false to "NA"
                          return value !== null &&
                            value !== undefined &&
                            value !== ""
                            ? value
                            : "NA";
                        })()
                      )}
                    </td>
                  ))}
                </tr>
                {tableType === "expandable" && expandedRows[rowIndex] && (
                  <tr>
                    <td
                      colSpan={visibleColumns.length + 1}
                      style={{
                        padding: 0,
                        position: "relative",
                        borderBottom: "1px solid #d1d5db",
                      }}
                    >
                      <div
                        style={{
                          padding: "16px 16px 16px 60px",
                          backgroundColor: "#f8fafc",
                        }}
                      >
                        <div
                          style={{
                            backgroundColor: "white",
                            borderRadius: "8px",
                            border: "1px solid #e2e8f0",
                            position: "relative",
                            zIndex: 5,
                          }}
                        >
                          <div
                            style={{
                              padding: "16px",
                              borderBottom: "1px solid #e5e7eb",
                            }}
                          >
                            <h4
                              style={{
                                margin: 0,
                                fontSize: "16px",
                                fontWeight: "600",
                                textAlign: "center",
                              }}
                            >
                              Detailed view
                            </h4>
                          </div>
                          <div
                            style={{
                              overflowX: "auto",
                              maxHeight: "300px",
                              overflowY: "auto",
                              position: "relative",
                            }}
                          >
                            <table
                              style={{
                                width: "100%",
                                borderCollapse: "collapse",
                                position: "relative",
                              }}
                            >
                              <thead
                                style={{
                                  position: "sticky",
                                  top: 0,
                                  zIndex: 25,
                                }}
                              >
                                <tr
                                  style={{
                                    ...subHeaderStyle,
                                    borderBottom: "1px solid #e5e7eb",
                                  }}
                                >
                                  {visibleSubColumns.map((col, index) => (
                                    <th
                                      key={col.key}
                                      style={{
                                        padding: "12px 16px",
                                        textAlign: "center",
                                        fontWeight: "600",
                                        background: item.subHeaderColor,
                                        color: item.subHeaderTextColor,
                                        position: "sticky",
                                        top: 0,
                                        zIndex: 26,
                                        borderRight:
                                          index < visibleSubColumns.length - 1
                                            ? "1px solid #d1d5db"
                                            : "none",
                                      }}
                                    >
                                      {col.label}
                                    </th>
                                  ))}
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  {visibleSubColumns.map((col, index) => (
                                    <td
                                      key={col.key}
                                      style={{
                                        padding: "0px 5px",
                                        borderBottom: "1px solid #d1d5db",
                                        textAlign: col.alignment || "left", // Apply alignment
                                        borderRight:
                                          index < visibleSubColumns.length - 1
                                            ? "1px solid #d1d5db"
                                            : "none",
                                      }}
                                    >
                                      {(() => {
                                        const value = row[col.key];

                                        // Handle boolean values
                                        if (typeof value === "boolean") {
                                          return value ? "Yes" : "No";
                                        }
                                        const isDateField =
                                          col.type === "date" ||
                                          (typeof value === "string" &&
                                            /\d{4}-\d{2}-\d{2}/.test(value));

                                        if (isDateField && value) {
                                          return formatDateForDisplay(value);
                                        }

                                        // Use strict null/undefined check to avoid converting false to "NA"
                                        return value !== null &&
                                          value !== undefined &&
                                          value !== ""
                                          ? value
                                          : "NA";
                                      })()}
                                    </td>
                                  ))}
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>

      {/* No records message */}
      {currentRows.length === 0 && (
        <div
          style={{
            flexShrink: 0, // Prevent shrinking
            padding: "24px",
            textAlign: "center",
            color: "#6b7280",
          }}
        >
          No matching records found
        </div>
      )}

      {/* Pagination Section - Always visible at bottom */}
      {showPagination && sortedData.length > 0 && (
        <div
          style={{
            flexShrink: 0, // Prevent shrinking
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginTop: "16px",
            padding: "8px 0",
            borderTop: "1px solid #e5e7eb",
            backgroundColor: "white", // Ensure it stands out
            position: "sticky", // Make it sticky to bottom
            bottom: 0,
            zIndex: 10,
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <span style={{ fontSize: "14px", color: "#6b7280" }}>
              Rows per page:
            </span>
            <select
              value={currentRowsPerPage}
              onChange={(e) => {
                const newValue = Number(e.target.value);
                if (onTableRowsPerPageChange) {
                  onTableRowsPerPageChange(newValue);
                }
              }}
              style={{
                padding: "4px 8px",
                borderRadius: "4px",
                border: "1px solid #d1d5db",
                backgroundColor: "white",
                fontSize: "14px",
                color: "#374151",
              }}
            >
              {generatePaginationOptions(sortedData.length).map((size) => (
                <option key={size} value={size}>
                  {size === sortedData.length ? `All (${size})` : size}
                </option>
              ))}
            </select>
          </div>

          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <span style={{ fontSize: "14px", color: "#6b7280" }}>
              {indexOfFirstRow + 1}-{Math.min(indexOfLastRow, totalRows)} of{" "}
              {totalRows}
            </span>
            <button
              onClick={() => {
                if (onTablePageChange && currentPage > 1) {
                  onTablePageChange(currentPage - 1);
                }
              }}
              disabled={currentPage === 1}
              style={{
                padding: "4px 8px",
                backgroundColor: currentPage === 1 ? "#f3f4f6" : "#e5e7eb",
                color: currentPage === 1 ? "#9ca3af" : "#374151",
                border: "none",
                borderRadius: "4px",
                cursor: currentPage === 1 ? "not-allowed" : "pointer",
              }}
            >
              <ChevronLeft size={16} />
            </button>
            <button
              onClick={() => {
                if (onTablePageChange && currentPage < totalPages) {
                  onTablePageChange(currentPage + 1);
                }
              }}
              disabled={currentPage >= totalPages}
              style={{
                padding: "4px 8px",
                backgroundColor:
                  currentPage >= totalPages ? "#f3f4f6" : "#e5e7eb",
                color: currentPage >= totalPages ? "#9ca3af" : "#374151",
                border: "none",
                borderRadius: "4px",
                cursor: currentPage >= totalPages ? "not-allowed" : "pointer",
              }}
            >
              <ChevronRight size={16} />
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default TableComponent;
